module.exports = __webpack_public_path__ + "img/logo.3f79e705.png";